import React from "react";
import "./QuestionStatus.css";

function QuestionStatus() {
  return (
    <div className="qn-overview">
      <h4>Overview</h4>
      <div className="qn-overview-list">
        <div>
          <span className="qn-status notVisited">5</span>
          <span className="qn-status-text">Not Visited</span>
        </div>
        <div>
          <span className="qn-status answered">1</span>
          <span className="qn-status-text">Answered</span>
        </div>
        <div>
          <span className="qn-status notAnswered">2</span>
          <span className="qn-status-text">Not Answered</span>
        </div>
        <div>
          <span className="qn-status marked">5</span>
          <span className="qn-status-text">Marked for Review</span>
        </div>
        <div>
          <span className="qn-status answeredMarked">5</span>
          <span className="qn-status-text">Answered & Marked for Review</span>
        </div>
      </div>
    </div>
  );
}

export default QuestionStatus;
